import { useCallback, useMemo } from 'react'
import { modifyFloatingPaneActionCreator } from 'actions/floatingPanesActions'
import { FLOATING_PANE_CRYPTO_REWARDS_TYPE } from 'components/features/rewards/rewardsPane/constants/paneState'
import { useStoreDispatch, useStoreSelector } from 'helpers/reactReduxHelpers'
import { CryptoRewardsPaneModeWithSteps, CryptoRewardsPaneState } from 'components/features/rewards/rewardsPane/types/paneState'
import { createCryptoRewardsPaneFieldsStateForModeSelector } from 'components/features/rewards/rewardsPane/store/selectors/paneState'

export function useCryptoRewardsPaneModifyStateCallback <M extends CryptoRewardsPaneModeWithSteps> (mode: M): (buyModePaneState: Partial<CryptoRewardsPaneState<M>>) => void {
  const paneFieldsStateByModeSelector = useMemo(() => createCryptoRewardsPaneFieldsStateForModeSelector(mode), [mode])
  const currentFieldsState = useStoreSelector(paneFieldsStateByModeSelector)
  const dispatch = useStoreDispatch()

  const modifyCallback = useCallback((cryptoPaneState: Partial<CryptoRewardsPaneState<M>>): void => {
    const stepResulted = cryptoPaneState.step
    const fieldsResulted = {
      ...currentFieldsState,
      ...cryptoPaneState.fields,
    }

    dispatch(modifyFloatingPaneActionCreator(
      FLOATING_PANE_CRYPTO_REWARDS_TYPE, {
        ...cryptoPaneState,
        ...(stepResulted ? { step: stepResulted } : undefined),
        fields: fieldsResulted,
      } as CryptoRewardsPaneState<M>
    ))
  }, [currentFieldsState, dispatch])

  return modifyCallback
}
